import styled from 'styled-components'

export const Wrapper = styled.div`
  .body-card{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0px, 1fr));
  }

  .divisor-container {
    margin-top: 6px;
  }

  .card-label{
    align-content: flex-start;
    span:first-child{
      line-height: 12px;
    }
    span:last-child{
      line-height: 14px;
      margin-top: 4px;
    }
  }

  .insumo-desc {
    top: -3px;
  }

  .description-bold{
    font-weight: var(--font-weight-semibold) !important;
    white-space: nowrap;
  }

  .card-shop-mester{
    width: 350px;
    height: 246px !important;
    margin: 0px;
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 38px;
  width: calc(100% - 16px);
  justify-content: end;
  margin-top: 12px;
`

export const Button = styled.button`
  width: 112px;
  height: 26px;
  margin-left: 6px;
  span{
    color: var(--color-contrast-white) !important;
    font-size: 10px !important;
  }
`
export const ButtonEdit = styled.button`
  width: 112px;
  height: 26px;
  border: 1px solid var(--color-action-default) !important;
  span{
    color: var(--color-action-default) !important;
    font-size: 10px !important;
  }
`
